/**
 * Hospital-specific product bundles and templates
 */

export const HOSPITAL_BUNDLES = {
  fireSafety: {
    id: 'fire-safety',
    name: '🔥 Fire & Life Safety Program',
    description: 'Comprehensive fire safety and life safety code compliance activities',
    productCount: 7,
    products: [
      {
        name: 'Fire Safety Inspections',
        baseHours: 416,
        comp: 10,
        risk: 35,
        env: 5,
        category: 'lifeSafety'
      },
      {
        name: 'Fire Drills & Evacuations',
        baseHours: 312,
        comp: 15,
        risk: 40,
        env: 0,
        category: 'lifeSafety'
      },
      {
        name: 'Hot Work Permit Management',
        baseHours: 260,
        comp: 20,
        risk: 35,
        env: 10,
        category: 'lifeSafety'
      },
      {
        name: 'Fire Alarm Testing Oversight',
        baseHours: 156,
        comp: 10,
        risk: 25,
        env: 0,
        category: 'lifeSafety'
      },
      {
        name: 'Fire Extinguisher Inspections',
        baseHours: 208,
        comp: 5,
        risk: 15,
        env: 0,
        category: 'lifeSafety'
      },
      {
        name: 'Emergency Egress Inspections',
        baseHours: 182,
        comp: 10,
        risk: 30,
        env: 0,
        category: 'lifeSafety'
      },
      {
        name: 'Life Safety Code Training',
        baseHours: 260,
        comp: 15,
        risk: 20,
        env: 0,
        category: 'lifeSafety'
      }
    ]
  },

  hospitalSafety: {
    id: 'hospital-safety',
    name: '🏥 Hospital Safety Essentials',
    description: 'Core safety programs for acute care hospitals',
    productCount: 6,
    products: [
      {
        name: 'Infection Control Coordination',
        baseHours: 520,
        comp: 25,
        risk: 40,
        env: 15,
        category: 'infectiousDisease'
      },
      {
        name: 'Surgical Suite Safety',
        baseHours: 390,
        comp: 30,
        risk: 35,
        env: 20,
        category: 'surgery'
      },
      {
        name: 'Radiation Safety Program',
        baseHours: 468,
        comp: 35,
        risk: 40,
        env: 25,
        category: 'radiology'
      },
      {
        name: 'Hazardous Drug Handling',
        baseHours: 416,
        comp: 30,
        risk: 40,
        env: 35,
        category: 'pharmacy'
      },
      {
        name: 'Patient Handling & Ergonomics',
        baseHours: 312,
        comp: 15,
        risk: 25,
        env: 5,
        category: 'regulatoryIntensity'
      },
      {
        name: 'Bloodborne Pathogen Program',
        baseHours: 260,
        comp: 20,
        risk: 35,
        env: 10,
        category: 'infectiousDisease'
      }
    ]
  },

  researchLabs: {
    id: 'research-labs',
    name: '🔬 Research Laboratory Safety',
    description: 'Safety programs for clinical and research laboratories',
    productCount: 5,
    products: [
      {
        name: 'Biosafety Program (BSL-2/3)',
        baseHours: 520,
        comp: 40,
        risk: 45,
        env: 30,
        category: 'researchLabs'
      },
      {
        name: 'Chemical Hygiene Plan',
        baseHours: 390,
        comp: 30,
        risk: 35,
        env: 30,
        category: 'researchLabs'
      },
      {
        name: 'Lab Safety Inspections',
        baseHours: 416,
        comp: 25,
        risk: 30,
        env: 25,
        category: 'researchLabs'
      },
      {
        name: 'Laboratory Waste Management',
        baseHours: 312,
        comp: 20,
        risk: 30,
        env: 40,
        category: 'researchLabs'
      },
      {
        name: 'Lab Equipment Safety',
        baseHours: 208,
        comp: 15,
        risk: 20,
        env: 10,
        category: 'researchLabs'
      }
    ]
  },

  environmental: {
    id: 'environmental',
    name: '🌱 Hospital Environmental Compliance',
    description: 'Environmental health and regulatory compliance',
    productCount: 5,
    products: [
      {
        name: 'Medical Waste Management',
        baseHours: 468,
        comp: 20,
        risk: 35,
        env: 45,
        category: 'regulatoryIntensity'
      },
      {
        name: 'Wastewater Discharge Compliance',
        baseHours: 312,
        comp: 25,
        risk: 25,
        env: 40,
        category: 'regulatoryIntensity'
      },
      {
        name: 'Air Quality Monitoring',
        baseHours: 390,
        comp: 30,
        risk: 20,
        env: 35,
        category: 'regulatoryIntensity'
      },
      {
        name: 'Hazardous Material Storage',
        baseHours: 260,
        comp: 20,
        risk: 30,
        env: 35,
        category: 'regulatoryIntensity'
      },
      {
        name: 'Environmental Permit Management',
        baseHours: 312,
        comp: 25,
        risk: 20,
        env: 30,
        category: 'regulatoryIntensity'
      }
    ]
  },

  jointCommission: {
    id: 'joint-commission',
    name: '📋 Joint Commission Readiness',
    description: 'Programs for Joint Commission accreditation compliance',
    productCount: 6,
    products: [
      {
        name: 'Environment of Care Rounds',
        baseHours: 520,
        comp: 20,
        risk: 25,
        env: 15,
        category: 'regulatoryIntensity'
      },
      {
        name: 'Utility System Management',
        baseHours: 312,
        comp: 25,
        risk: 30,
        env: 20,
        category: 'facilities'
      },
      {
        name: 'Medical Equipment Safety',
        baseHours: 390,
        comp: 20,
        risk: 25,
        env: 10,
        category: 'regulatoryIntensity'
      },
      {
        name: 'Emergency Management Program',
        baseHours: 416,
        comp: 30,
        risk: 35,
        env: 10,
        category: 'regulatoryIntensity'
      },
      {
        name: 'Hazard Vulnerability Analysis',
        baseHours: 156,
        comp: 25,
        risk: 20,
        env: 15,
        category: 'regulatoryIntensity'
      },
      {
        name: 'Safety Data Reporting',
        baseHours: 260,
        comp: 15,
        risk: 15,
        env: 5,
        category: 'regulatoryIntensity'
      }
    ]
  }
};

/**
 * Get all bundle IDs
 */
export const getBundleIds = () => Object.keys(HOSPITAL_BUNDLES);

/**
 * Get bundle by ID
 */
export const getBundleById = (bundleId) => HOSPITAL_BUNDLES[bundleId];

/**
 * Get all bundles as array
 */
export const getAllBundles = () => Object.values(HOSPITAL_BUNDLES);
